import { useParams, useNavigate, useOutletContext } from 'react-router-dom'
import MessageTemplateLoader from './MessageTemplateMaintenancePage'

const MessageTemplateItemsWrapper = (props) => {
  const params = useParams()
  const navigate = useNavigate()
  const outletContext = useOutletContext()

  return (
    <MessageTemplateLoader
      {...params}
      navigate={navigate}
      outletContext={outletContext}
      {...props}
    />
  )
}

export default MessageTemplateItemsWrapper
